import React from "react";

import FilterChip from "./../../components/FilterChip";
import FilterDate from "./../../components/FilterDate";
import FilterDriver from "./../../components/FilterDriver";
import FilterFrequency from "./../../components/FilterFrequency";
import FilterImaOperations from "./../../components/FilterImaOperations";
import FilterNipleOperation from "./../../components/FilterNipleOperation";
import FilterPatrimony from "./../../components/FilterPatrimony";
import FilterRoute from "./../../components/FilterRoute";
import FilterSavedArea from "./../../components/FilterSavedArea";
import FilterSpeeding from "./../../components/FilterSpeeding";
import FilterUser from "./../../components/FilterUser";
import FilterVirtualFence from "./../../components/FilterVirtualFence";

const Option = ({ options }) => {
  const {
    dateEnd,
    dateStart,
    limitDays,
    filterActive,
    filterChip,
    filterDriver,
    filterFrequency,
    filterImaOperations,
    filterMultiple,
    filterMultipleVirtualFence,
    filterNiple,
    filterNipleOperationType,
    filterPatrimony,
    filterPump,
    filterPreSelected,
    filterRoute,
    filterSavedArea,
    filterSpeeding,
    filterUser,
    filterVirtualFence
  } = options;

  const renderFilterChip = () => {
    if(filterChip) {
      return <FilterChip options={{ filterMultiple }} />;
    }
    return null;
  };

  const renderFilterDriver = () => {
    if(filterDriver) {
      return <FilterDriver options={{ filterMultiple }} />;
    }
    return null;
  };

  const renderFilterDate = () => {
    if(dateEnd || dateStart) {
      return <FilterDate options={{ dateEnd, dateStart, limitDays }} />;
    }
    return null;
  };

  const renderFilterFrequency = () => {
    if (filterFrequency) {
      return <FilterFrequency />;
    }
    return null;
  };

  const renderFilterNipleOperation = () => {
    if (filterNipleOperationType) {
      return <FilterNipleOperation />;
    }
    return null;
  };

  const renderFilterImaOperations = () => {
    if (filterImaOperations) {
      return <FilterImaOperations />;
    }
    return null;
  };

  const renderFilterSavedArea = () => {
    if (filterSavedArea) {
      return <FilterSavedArea />;
    }
    return null;
  };

  const renderFilterPatrimony = () => {
    if(filterPatrimony) {
      return <FilterPatrimony options={{ filterActive, filterMultiple, filterNiple, filterPump, filterPreSelected }} />;
    }
    return null;
  };

  const renderFilterRoute = () => {
    if (filterRoute) {
      return <FilterRoute />;
    }
    return null;
  };

  const renderFilterSpeeding = () => {
    if (filterSpeeding) {
      return <FilterSpeeding />;
    }
    return null;
  };

  const renderFilterUser = () => {
    if(filterUser) {
      return <FilterUser options={{ filterMultiple }} />;
    }
    return null;
  };

  const renderFilterVirtualFence = () => {
    if(filterVirtualFence) {
      return <FilterVirtualFence options={{ filterActive, filterMultipleVirtualFence, filterPreSelected }} />;
    }
    return null;
  };

  return (
    <>
	    {renderFilterChip()}
      {renderFilterDriver()}
      {renderFilterSpeeding()}
      {renderFilterFrequency()}
      {renderFilterRoute()}
      {renderFilterNipleOperation()}
      {renderFilterImaOperations()}
      {renderFilterDate()}
      {renderFilterPatrimony()}
      {renderFilterSavedArea()}
      {renderFilterUser()}
      {renderFilterVirtualFence()}
    </>
  );
};

export default Option;
